module.exports = __webpack_public_path__ + "static/img/CgoRDGORh6WAC9sZABTYQfDkns8274.02144d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGORh6WAC9sZABTYQfDkns8274.png
// module id = P+Zp
// module chunks = 73